import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../../DomainTypes';
import PortfolioType from '../../Models/Catalogue/Generic/PortfolioType';
import Bank from '../../Models/Catalogue/Generic/Bank';
import DocumentType from '../../Models/Catalogue/Generic/DocumentType';
import AssetClass from '../../Models/Catalogue/Generic/AssetClass';
import IssuerType from '../../Models/Catalogue/General/IssuerType';
import ShareType from '../../Models/Catalogue/General/ShareType';
import Title from '../../Models/Catalogue/Generic/Title';
import IntraGroup from '../../Models/Catalogue/Generic/IntraGroup';
import Country from '../../Models/Catalogue/General/Country';
import Sector from '../../Models/Catalogue/Reporting/Sector';
import NoteType from '../../Models/Catalogue/Generic/NoteType';
import Note from '../../Models/Notes/Note';
import AssetType from '../../Models/Catalogue/Classifications/AssetType';
import GLAccountType from '../../Models/Catalogue/General/GLAccountType';
import SARSIDType from '../../Models/Catalogue/General/SARSIDType';
import LegalEntityType from '../../Models/Catalogue/Classifications/LegalEntityType';
import DwtExemption from '../../Models/Catalogue/General/DwtExemption';
import ContactType from '../../Models/Catalogue/General/ContactType';
import SARSNatureOfPerson from '../../Models/Catalogue/General/SARSNatureOfPerson';
import ProductType from '../../Models/Catalogue/General/ProductType';
import MergeTemplate from '../../Models/Catalogue/General/MergeTemplate';
import DistributionType from '../../Models/Catalogue/Classifications/DistributionType';

export interface IGenericApiClient {

    getPortfolioTypes(): AxiosPromise<Array<Model.PlainTrackedObject<PortfolioType>>>;

    savePortfolioTypes(portfolioTypes: Array<Model.PartialPlainObject<PortfolioType>>): AxiosPromise<Array<Model.PlainTrackedObject<PortfolioType>>>;

    getBanks(): AxiosPromise<Array<Model.PlainTrackedObject<Bank>>>;

    saveBanks(banks: Array<Model.PartialPlainObject<Bank>>): AxiosPromise<Array<Model.PlainTrackedObject<Bank>>>;

    getDocumentTypes(): AxiosPromise<Array<Model.PlainTrackedObject<DocumentType>>>;

    saveDocumentTypes(documentTypes: Array<Model.PartialPlainObject<DocumentType>>): AxiosPromise<Array<Model.PlainTrackedObject<DocumentType>>>;

    getAssetClasses(): AxiosPromise<Array<Model.PlainTrackedObject<AssetClass>>>;

    saveAssetClasses(assetClasses: Array<Model.PartialPlainObject<AssetClass>>): AxiosPromise<Array<Model.PlainTrackedObject<AssetClass>>>;

    getIssuerTypes(): AxiosPromise<Array<Model.PlainTrackedObject<IssuerType>>>;

    saveIssuerTypes(issuerTypes: Array<Model.PartialPlainObject<IssuerType>>): AxiosPromise<Array<Model.PlainTrackedObject<IssuerType>>>;

    getShareTypes(): AxiosPromise<Array<Model.PlainTrackedObject<ShareType>>>;

    saveShareTypes(shareTypes: Array<Model.PartialPlainObject<ShareType>>): AxiosPromise<Array<Model.PlainTrackedObject<ShareType>>>;

    getTitles(): AxiosPromise<Array<Model.PlainTrackedObject<Title>>>;

    saveTitles(titles: Array<Model.PartialPlainObject<Title>>): AxiosPromise<Array<Model.PlainTrackedObject<Title>>>;

    getIntraGroups(): AxiosPromise<Array<Model.PlainTrackedObject<IntraGroup>>>;

    saveIntraGroups(intraGroups: Array<Model.PartialPlainObject<IntraGroup>>): AxiosPromise<Array<Model.PlainTrackedObject<IntraGroup>>>;

    getCountries(): AxiosPromise<Array<Model.PlainTrackedObject<Country>>>;

    saveCountries(countries: Array<Model.PartialPlainObject<Country>>): AxiosPromise<Array<Model.PlainTrackedObject<Country>>>;

    getSectors(): AxiosPromise<Array<Model.PlainTrackedObject<Sector>>>;

    saveSectors(sectors: Array<Model.PartialPlainObject<Sector>>): AxiosPromise<Array<Model.PlainTrackedObject<Sector>>>;

    getNoteTypes(): AxiosPromise<Array<Model.PlainTrackedObject<NoteType>>>;

    saveNoteTypes(noteTypes: Array<Model.PartialPlainObject<NoteType>>): AxiosPromise<Array<Model.PlainTrackedObject<NoteType>>>;

    saveNote(note: Model.PartialPlainObject<Note>): AxiosPromise<Model.PlainTrackedObject<Note>>;

    completeNote(noteId: number): AxiosPromise<Model.PlainTrackedObject<Note>>;

    getAssetTypes(): AxiosPromise<Array<Model.PlainTrackedObject<AssetType>>>;

    saveAssetTypes(assetTypes: Array<Model.PartialPlainObject<AssetType>>): AxiosPromise<Array<Model.PlainTrackedObject<AssetType>>>;

    getGLAccountTypes(): AxiosPromise<Array<Model.PlainTrackedObject<GLAccountType>>>;

    saveGLAccountTypes(glAccountType: Array<Model.PartialPlainObject<GLAccountType>>): AxiosPromise<Array<Model.PlainTrackedObject<GLAccountType>>>;

    getLegalEntityTypes(): AxiosPromise<Array<Model.PlainTrackedObject<LegalEntityType>>>;

    saveLegalEntityTypes(legalEntityTypes: Array<Model.PartialPlainObject<LegalEntityType>>): AxiosPromise<Array<Model.PlainTrackedObject<LegalEntityType>>>;

    getSARSIDTypes(): AxiosPromise<Array<Model.PlainTrackedObject<SARSIDType>>>;

    saveSARSIDTypes(sarsIDTypes: Array<Model.PartialPlainObject<SARSIDType>>): AxiosPromise<Array<Model.PlainTrackedObject<SARSIDType>>>;

    getDwtExemptions(): AxiosPromise<Array<Model.PlainTrackedObject<DwtExemption>>>;

    saveDwtExemptions(dwtExemptions: Array<Model.PartialPlainObject<DwtExemption>>): AxiosPromise<Array<Model.PlainTrackedObject<DwtExemption>>>;

    getContactTypes(): AxiosPromise<Array<Model.PlainTrackedObject<ContactType>>>;

    saveContactTypes(contactTypes: Array<Model.PartialPlainObject<ContactType>>): AxiosPromise<Array<Model.PlainTrackedObject<ContactType>>>;

    getSARSNatureOfPerson(): AxiosPromise<Array<Model.PlainTrackedObject<SARSNatureOfPerson>>>;

    saveSARSNatureOfPerson(sarsNatureOfPerson: Array<Model.PartialPlainObject<SARSNatureOfPerson>>): AxiosPromise<Array<Model.PlainTrackedObject<SARSNatureOfPerson>>>;

    getProductTypes(): AxiosPromise<Array<Model.PlainTrackedObject<ProductType>>>;

    saveProductTypes(productTypes: Array<Model.PartialPlainObject<ProductType>>): AxiosPromise<Array<Model.PlainTrackedObject<ProductType>>>;

    getMergeTemplates(): AxiosPromise<Array<Model.PlainTrackedObject<MergeTemplate>>>;

    saveMergeTemplates(mergeTemplates: Array<Model.PartialPlainObject<MergeTemplate>>): AxiosPromise<Array<Model.PlainTrackedObject<MergeTemplate>>>;

    getDistributionTypes(): AxiosPromise<Array<Model.PlainTrackedObject<DistributionType>>>;

    saveDistributionTypes(distributions: Array<Model.PartialPlainObject<DistributionType>>): AxiosPromise<Array<Model.PlainTrackedObject<DistributionType>>>;
    // Client only properties / methods
}

@injectable()
export default class GenericApiClient extends Data.ApiClientBase implements IGenericApiClient {

    constructor(config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/catalogue/generic`);
    }

    public getPortfolioTypes(): AxiosPromise<Array<Model.PlainTrackedObject<PortfolioType>>> {
        return this.axios.get(`${this.apiPath}/portfolio-types`);
    }

    public savePortfolioTypes(portfolioTypes: Array<Model.PartialPlainObject<PortfolioType>>): AxiosPromise<Array<Model.PlainTrackedObject<PortfolioType>>> {
        return this.axios.post(`${this.apiPath}/portfolio-types`, portfolioTypes);
    }

    public getBanks(): AxiosPromise<Array<Model.PlainTrackedObject<Bank>>> {
        return this.axios.get(`${this.apiPath}/banks`);
    }

    public saveBanks(banks: Array<Model.PartialPlainObject<Bank>>): AxiosPromise<Array<Model.PlainTrackedObject<Bank>>> {
        return this.axios.post(`${this.apiPath}/banks`, banks);
    }

    public getDocumentTypes(): AxiosPromise<Array<Model.PlainTrackedObject<DocumentType>>> {
        return this.axios.get(`${this.apiPath}/document-types`);
    }

    public saveDocumentTypes(documentTypes: Array<Model.PartialPlainObject<DocumentType>>): AxiosPromise<Array<Model.PlainTrackedObject<DocumentType>>> {
        return this.axios.post(`${this.apiPath}/document-types`, documentTypes);
    }

    public getAssetClasses(): AxiosPromise<Array<Model.PlainTrackedObject<AssetClass>>> {
        return this.axios.get(`${this.apiPath}/asset-classes`);
    }

    public saveAssetClasses(assetClasses: Array<Model.PartialPlainObject<AssetClass>>): AxiosPromise<Array<Model.PlainTrackedObject<AssetClass>>> {
        return this.axios.post(`${this.apiPath}/asset-classes`, assetClasses);
    }

    public getIssuerTypes(): AxiosPromise<Array<Model.PlainTrackedObject<IssuerType>>> {
        return this.axios.get(`${this.apiPath}/issuer-types`);
    }

    public saveIssuerTypes(issuerTypes: Array<Model.PartialPlainObject<IssuerType>>): AxiosPromise<Array<Model.PlainTrackedObject<IssuerType>>> {
        return this.axios.post(`${this.apiPath}/issuer-types`, issuerTypes);
    }

    public getShareTypes(): AxiosPromise<Array<Model.PlainTrackedObject<ShareType>>> {
        return this.axios.get(`${this.apiPath}/share-types`);
    }

    public saveShareTypes(shareTypes: Array<Model.PartialPlainObject<ShareType>>): AxiosPromise<Array<Model.PlainTrackedObject<ShareType>>> {
        return this.axios.post(`${this.apiPath}/share-types`, shareTypes);
    }

    public getTitles(): AxiosPromise<Array<Model.PlainTrackedObject<Title>>> {
        return this.axios.get(`${this.apiPath}/titles`);
    }

    public saveTitles(titles: Array<Model.PartialPlainObject<Title>>): AxiosPromise<Array<Model.PlainTrackedObject<Title>>> {
        return this.axios.post(`${this.apiPath}/titles`, titles);
    }

    public getIntraGroups(): AxiosPromise<Array<Model.PlainTrackedObject<IntraGroup>>> {
        return this.axios.get(`${this.apiPath}/intra-groups`);
    }

    public saveIntraGroups(intraGroups: Array<Model.PartialPlainObject<IntraGroup>>): AxiosPromise<Array<Model.PlainTrackedObject<IntraGroup>>> {
        return this.axios.post(`${this.apiPath}/intra-groups`, intraGroups);
    }

    public getCountries(): AxiosPromise<Array<Model.PlainTrackedObject<Country>>> {
        return this.axios.get(`${this.apiPath}/countries`);
    }

    public saveCountries(countries: Array<Model.PartialPlainObject<Country>>): AxiosPromise<Array<Model.PlainTrackedObject<Country>>> {
        return this.axios.post(`${this.apiPath}/countries`, countries);
    }

    public getSectors(): AxiosPromise<Array<Model.PlainTrackedObject<Sector>>> {
        return this.axios.get(`${this.apiPath}/sectors`);
    }

    public saveSectors(sectors: Array<Model.PartialPlainObject<Sector>>): AxiosPromise<Array<Model.PlainTrackedObject<Sector>>> {
        return this.axios.post(`${this.apiPath}/sectors`, sectors);
    }

    public getNoteTypes(): AxiosPromise<Array<Model.PlainTrackedObject<NoteType>>> {
        return this.axios.get(`${this.apiPath}/note-types`);
    }

    public saveNoteTypes(noteTypes: Array<Model.PartialPlainObject<NoteType>>): AxiosPromise<Array<Model.PlainTrackedObject<NoteType>>> {
        return this.axios.post(`${this.apiPath}/note-types`, noteTypes);
    }

    public saveNote(note: Model.PartialPlainObject<Note>): AxiosPromise<Model.PlainTrackedObject<Note>> {
        return this.axios.post(`${this.apiPath}/note`, note);
    }

    public completeNote(noteId: number): AxiosPromise<Model.PlainTrackedObject<Note>> {
        return this.axios.post(`${this.apiPath}/complete-note/${noteId}`);
    }

    public getAssetTypes(): AxiosPromise<Array<Model.PlainTrackedObject<AssetType>>> {
        return this.axios.get(`${this.apiPath}/asset-types`);
    }

    public saveAssetTypes(assetTypes: Array<Model.PartialPlainObject<AssetType>>): AxiosPromise<Array<Model.PlainTrackedObject<AssetType>>> {
        return this.axios.post(`${this.apiPath}/asset-types`, assetTypes);
    }

    public getGLAccountTypes(): AxiosPromise<Array<Model.PlainTrackedObject<GLAccountType>>> {
        return this.axios.get(`${this.apiPath}/gl-account-types`);
    }

    public saveGLAccountTypes(glAccountType: Array<Model.PartialPlainObject<GLAccountType>>): AxiosPromise<Array<Model.PlainTrackedObject<GLAccountType>>> {
        return this.axios.post(`${this.apiPath}/gl-account-types`, glAccountType);
    }

    public getLegalEntityTypes(): AxiosPromise<Array<Model.PlainTrackedObject<LegalEntityType>>> {
        return this.axios.get(`${this.apiPath}/legal-entity-types`);
    }

    public saveLegalEntityTypes(legalEntityTypes: Array<Model.PartialPlainObject<LegalEntityType>>): AxiosPromise<Array<Model.PlainTrackedObject<LegalEntityType>>> {
        return this.axios.post(`${this.apiPath}/legal-entity-types`, legalEntityTypes);
    }

    public getSARSIDTypes(): AxiosPromise<Array<Model.PlainTrackedObject<SARSIDType>>> {
        return this.axios.get(`${this.apiPath}/sars-id-types`);
    }

    public saveSARSIDTypes(sarsIDTypes: Array<Model.PartialPlainObject<SARSIDType>>): AxiosPromise<Array<Model.PlainTrackedObject<SARSIDType>>> {
        return this.axios.post(`${this.apiPath}/sars-id-types`, sarsIDTypes);
    }

    public getDwtExemptions(): AxiosPromise<Array<Model.PlainTrackedObject<DwtExemption>>> {
        return this.axios.get(`${this.apiPath}/dwt-exemptions`);
    }

    public saveDwtExemptions(dwtExemptions: Array<Model.PartialPlainObject<DwtExemption>>): AxiosPromise<Array<Model.PlainTrackedObject<DwtExemption>>> {
        return this.axios.post(`${this.apiPath}/dwt-exemptions`, dwtExemptions);
    }

    public getContactTypes(): AxiosPromise<Array<Model.PlainTrackedObject<ContactType>>> {
        return this.axios.get(`${this.apiPath}/contact-types`);
    }

    public saveContactTypes(contactTypes: Array<Model.PartialPlainObject<ContactType>>): AxiosPromise<Array<Model.PlainTrackedObject<ContactType>>> {
        return this.axios.post(`${this.apiPath}/contact-types`, contactTypes);
    }

    public getSARSNatureOfPerson(): AxiosPromise<Array<Model.PlainTrackedObject<SARSNatureOfPerson>>> {
        return this.axios.get(`${this.apiPath}/sars-nature-of-person`);
    }

    public saveSARSNatureOfPerson(sarsNatureOfPerson: Array<Model.PartialPlainObject<SARSNatureOfPerson>>): AxiosPromise<Array<Model.PlainTrackedObject<SARSNatureOfPerson>>> {
        return this.axios.post(`${this.apiPath}/sars-nature-of-person`, sarsNatureOfPerson);
    }

    public getProductTypes(): AxiosPromise<Array<Model.PlainTrackedObject<ProductType>>> {
        return this.axios.get(`${this.apiPath}/product-types`);
    }

    public saveProductTypes(productTypes: Array<Model.PartialPlainObject<ProductType>>): AxiosPromise<Array<Model.PlainTrackedObject<ProductType>>> {
        return this.axios.post(`${this.apiPath}/product-types`, productTypes);
    }

    public getMergeTemplates(): AxiosPromise<Array<Model.PlainTrackedObject<MergeTemplate>>> {
        return this.axios.get(`${this.apiPath}/merge-templates`);
    }

    public saveMergeTemplates(mergeTemplates: Array<Model.PartialPlainObject<MergeTemplate>>): AxiosPromise<Array<Model.PlainTrackedObject<MergeTemplate>>> {
        return this.axios.post(`${this.apiPath}/merge-templates`, mergeTemplates);
    }

    public getDistributionTypes(): AxiosPromise<Array<Model.PlainTrackedObject<DistributionType>>> {
        return this.axios.get(`${this.apiPath}/distribution-types`);
    }

    public saveDistributionTypes(distributions: Array<Model.PartialPlainObject<DistributionType>>): AxiosPromise<Array<Model.PlainTrackedObject<DistributionType>>> {
        return this.axios.post(`${this.apiPath}/distribution-types`, distributions);
    }

    // Client only properties / methods
}